import { Route } from 'react-router-dom'
import { Routes } from 'react-router-dom'
import UsersListPage from './pages/users-list'

export default function UsersPage() {
  return (
    <Routes>
      <Route path="/" element={<UsersListPage />} />
    </Routes>
  )
}
